export enum YMMType {
    standard = 'standard',
    infotainment = 'infotainment',
}
